import { Link } from "react-router-dom";
import { useGetAllPhoneNumber } from "../../hooks/query/useGetAllPhoneNumber";

function Footer() {
    const { data } = useGetAllPhoneNumber(1, 10);
    console.log("phone", data);  
    const phones = data?.items ?? [];
    return (
        <footer className="pt-[40px] flex flex-col pb-[20px] bg-dark lg:px-[40px]">
            <div className="flex flex-col lg:flex-row lg:justify-between gap-x-[20px] p-[20px]">
                <div className="lg:items-start lg:max-w-[25%]">
                    <h3 className="text-accent font-bold text-[20px]">Trung Tâm Tri Thức Số</h3>
                    <p className="text-white text-[18px] my-[20px] text-justify">
                        Chuyên đào tạo các môn học từ cấp 1 đến cấp 3 và các khóa tin học ứng dụng.
                    </p>
                    <div className="flex items-center gap-x-[10px]">
                        <a
                            href="https://facebook.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-icon flex justify-center items-center w-[40px] h-[40px] rounded-full bg-white/10 hover:text-white hover:bg-accent transition-colors duration-300"
                        >
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a
                            href="https://twitter.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-icon flex justify-center items-center w-[40px] h-[40px] rounded-full bg-white/10 hover:text-white hover:bg-accent transition-colors duration-300"
                        >
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-icon flex justify-center items-center w-[40px] h-[40px] rounded-full bg-white/10 hover:text-white hover:bg-accent transition-colors duration-300"
                        >
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a
                            href="https://youtube.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-icon flex justify-center items-center w-[40px] h-[40px] rounded-full bg-white/10 hover:text-white hover:bg-accent transition-colors duration-300"
                        >
                            <i className="fab fa-youtube"></i>
                        </a>
                    </div>
                </div>
                <div className="flex flex-col mt-[40px] lg:mt-0 lg:items-start">
                    <h3 className="text-accent font-bold text-[20px] my-[20px] lg:mt-0">Khóa Học</h3>
                    <Link to="/khoa-hoc/tien-tieu-hoc" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Tiền Tiểu học
                    </Link>
                    <Link to="/khoa-hoc/cap-1" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Cấp 1
                    </Link>

                    <Link to="/khoa-hoc/cap-2" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Cấp 2
                    </Link>

                    <Link to="/khoa-hoc/cap-3" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Cấp 3
                    </Link>

                    <Link to="/khoa-hoc/tin-hoc" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Tin học
                    </Link>
                </div>
                <div className="flex flex-col mt-[40px] lg:mt-0 lg:items-start">
                    <h3 className="text-accent font-bold text-[20px] my-[20px] lg:mt-0">Liên kết</h3>
                    <Link to="/" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Trang chủ
                    </Link>
                    <Link to="/about-us" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Về chúng tôi
                    </Link>

                    <Link to="/course" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Khóa học
                    </Link>

                    <Link to="/branch" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Cơ sở
                    </Link>

                    <Link to="/contact" className="text-tag text-[18px] my-[4px] hover:text-accent">
                        Liên hệ
                    </Link>
                </div>
                <div className="flex flex-col mt-[40px] lg:mt-0 lg:items-start">
                    <h3 className="text-accent font-bold text-[20px] my-[20px] lg:mt-0">Liên hệ</h3>
                    {phones.map((phone: any) => (
                        <p key={phone.id} className="flex items-center">
                            <i className="fas fa-phone text-white w-[18px] h-[18px] text-[18px]"></i>
                            <span className="text-white text-[18px] my-[4px] ml-[8px]">
                                {phone.phoneNumber}
                            </span>
                        </p>
                    ))}

                </div>
            </div>
            <p className="border-t border-[rgba(255,255,255,0.1)] text-tag text-center pt-[20px]">© 2023 Trung Tâm Tri Thức Số. Tất cả các quyền được bảo lưu.</p>
        </footer>
    );
}

export default Footer;
